
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getMessageList, getNoticeList, readMessage, readNotice, deleteMessage } from '@/api/system';
import { formatTime } from '@/utils/index';

@Component({
  name: 'messageList',
  components: {

  }
})
export default class extends Vue {
  private activeName = 'first'
  private tableDataNotice = []
  private message = []
  private notice = []
  // 页面参数定义
  private messagePagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  @Watch('messagePagination', {
    deep: true,
    immediate: true
  })handelChangeMessagePagination() {
    this.getMessageList();
  }
  handleMessageCurrentChange(size:number) {
    this.messagePagination.currentPage = size;
  }

  handleMessagePageSizeChange(size: number) {
    this.messagePagination.pageSize = size;
  }
  getMessageList() {
    const params = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      page: this.messagePagination.currentPage,
      size: this.messagePagination.pageSize
    };
    getMessageList(params).then(res => {
      if (res && res.data) {
        this.messagePagination.currentPage = parseInt(res.data.page_current);
        this.messagePagination.total = parseInt(res.data.count);
        this.messagePagination.pageSize = parseInt(res.data.page_size);
        this.message = res.data.list;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  handleConfirm(val: any) {
    this.$alert(val.msg_content, '通知', {
      showConfirmButton: false,
      callback: action => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          id: val.id
        };
        readMessage(params).then(res => {
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
      }
    });
  }
  handleDelete(val: any) {
    this.$confirm('确认删除').then(res => {
      const params = {
        user_id: UserModule.getUserId,
        company_id: UserModule.getCompanyId,
        id: val.id
      };
      deleteMessage(params).then(res => {
        this.getMessageList();
        this.showSecussMsg('删除成功');
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    });
  }
  private noticePagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  @Watch('noticePagination', {
    deep: true,
    immediate: true
  })handelChangeNoticePagination() {
    this.getNoticeList();
  }
  handleNoticeCurrentChange(size:number) {
    this.noticePagination.currentPage = size;
  }

  handleNoticePageSizeChange(size: number) {
    this.noticePagination.pageSize = size;
  }
  getNoticeList() {
    const params = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      is_read: 0,
      page: this.noticePagination.currentPage,
      size: this.noticePagination.pageSize
    };
    getNoticeList(params).then(res => {
      if (res && res.data) {
        this.noticePagination.currentPage = parseInt(res.data.page_current);
        this.noticePagination.total = parseInt(res.data.count);
        this.noticePagination.pageSize = parseInt(res.data.page_size);
        this.notice = res.data.list;
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  handleDetail(val: any) {
    const h = this.$createElement;
    this.$msgbox({
      title: '公告',
      message: h('div', undefined, [
        h('h3', undefined, val.notice_title),
        h('p', { style: 'color: #999' }, [
          h('span', undefined, val.notice_author),
          h('span', { style: 'margin-left: 15px' }, formatTime(parseInt(val.addtime), '{y}-{m}-{d} {h}:{i}'))
        ]),
        h('p', {
          domProps: {
            innerHTML: val.notice_content
          }
        })
      ]),
      showConfirmButton: false,
      callback: action => {
        // const params = {
        //   user_id: UserModule.getUserId,
        //   company_notice_id: val.id
        // };
        // readNotice(params).then(res => {
        //   this.getNoticeList();
        // }).catch(err => {
        //   this.showErrorMsg(err.msg);
        // });
      }
    }).then(action => {
      this.$message({
        type: 'info',
        message: 'action: ' + action
      });
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
